const APPID = "JHA-030";
function genUUID() {
  return (
    Math.random()
      .toString()
      .substr(2, 36) + Date.now().toString(36)
  );
}
export function getTraceId() {
  let str = sessionStorage.getItem(`${APPID}_traceId`);
  if (str) return str;
  str =
    Math.random()
      .toString()
      .substr(2, 36) + Date.now().toString(36);
  sessionStorage.setItem(`${APPID}_traceId`, str);
  return str;
}

/**
 * 组装公共字段
 * vm: 组件 this 引用，用于读取 route/query、window 等
 */
function buildCommon(vm) {
  const ua = navigator.userAgent || "";
  const query = (vm && vm.$route && vm.$route.query) || {};
  const channel = query.dc || query.ch || JSON.stringify(query) || "";
  return {
    event: "", // 调用时设置
    channel: channel,
    event_id: genUUID(),
    app_id: APPID,
    uid: genUUID(), // 如有可传
    sid: genUUID(),
    client_ts: Math.floor(Date.now() / 1000),
    device: (() => {
      const uaLow = ua.toLowerCase();
      if (/android/.test(uaLow)) return "Android";
      if (/iphone|ipad|ipod|ios/.test(uaLow)) return "iOS";
      return "PC";
    })(),
    device_id: genUUID(),
    user_agent: ua,
    device_brand: "",
    device_model: "",
    ip: "", // 服务端生成，前端可留空
    payload: "", // 服务端生成，前端留空
  };
}
/**
 * 上报落地页展示
 * vm: 组件 this，必须传
 * opts: { landing_page_id }
 */
export function landingPageView(vm, opts = {}) {
  const common = buildCommon(vm);
  const data = {
    ...common,
    event: "landing_page_view",
    landing_page_id: opts.landing_page_id || `${APPID}_${vm.version}`,
  };
  return window.tracker(data);
}

/**
 * 上报落地页点击
 * vm: 组件 this
 * opts: {
 *   landing_page_id,
 *   tab_key,
 *   tab_name,
 *   click_coordinates_x,
 *   click_coordinates_y,
 *   click_x_percent,
 *   click_y_percent,
 *   screen_width,
 *   screen_height,
 *   trace_id
 * }
 */
export function landingPageClick(vm, opts = {}) {
  const common = buildCommon(vm);
  const screenW = window.screen ? window.screen.width : opts.screen_width || 0;
  const screenH = window.screen
    ? window.screen.height
    : opts.screen_height || 0;
  const data = {
    ...common,
    event: "landing_page_click",
    landing_page_id: opts.landing_page_id || `${APPID}_${vm.version}`,
    tab_key: opts.tab_key || "",
    tab_name: opts.tab_name || "",
    click_coordinates_x: opts.click_coordinates_x || 0,
    click_coordinates_y: opts.click_coordinates_y || 0,
    click_x_percent:
      typeof opts.click_x_percent === "number"
        ? opts.click_x_percent
        : Math.round(((opts.click_coordinates_x || 0) / (screenW || 1)) * 100),
    click_y_percent:
      typeof opts.click_y_percent === "number"
        ? opts.click_y_percent
        : Math.round(((opts.click_coordinates_y || 0) / (screenH || 1)) * 100),
    screen_width: screenW,
    screen_height: screenH,
    trace_id: opts.trace_id || getTraceId(),
  };
  return window.tracker(data);
}

// 防抖函数（wait 毫秒内重复触发只会执行最后一次），如需改为立即触发并节流可把 immediate 设为 true
// function debounce(fn, wait = 300, immediate = false) {
//   let timer = null;
//   return function(...args) {
//     const ctx = this;
//     if (timer) clearTimeout(timer);
//     if (immediate) {
//       const callNow = !timer;
//       timer = setTimeout(() => {
//         timer = null;
//       }, wait);
//       if (callNow) fn.apply(ctx, args);
//     } else {
//       timer = setTimeout(() => {
//         fn.apply(ctx, args);
//       }, wait);
//     }
//   };
// }

// export function pageClickHandler(vm, opts = {}){
//   debounce(landingPageClick, 300, false)
// }
